jQuery(document).ready(function($){

  // sustain page blog slider

//   if(window.innerWidth <= 767){
//     $('.sustain_blog_section_inner article-list').slick({
//   infinite: false,
//   slidesToShow: 3,
//   slidesToScroll: 1,
//     centerMode: true,
//   centerPadding: '0px',
//     responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         centerPadding: '40px'
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll:1,
//         centerPadding: '40px'
//       }
//     },
//     {
//       breakpoint: 520,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         ccenterPadding: '40px'
//       }
//     }
//     // You can unslick at a given breakpoint now by adding:
//     // settings: "unslick"
//     // instead of a settings object
//   ]
// });
//  };

  


  // end
  

  $('.mobile_slider_main').on('init', function(event, slick){
        if (slick.slideCount === 1) {
            $('.slick-dots').hide();
        }
    });

  // collection top banner slider

  $('.collection-top-banner-images').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnFocus: false,
    pauseOnHover: false
});
  // end

   $(".filter_option_fixed_top .product-facet__filter-list>.product-facet__filter-item:first-child button").html(`Product Category Filter <svg focusable="false" width="12" height="8" class="icon icon--chevron icon--inline  " viewBox="0 0 12 8">
        <path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2"></path>
      </svg>`);


  
  $('.sustain_testimonial-section-main .testimonial-wrapper').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
    centerMode: true,
  centerPadding: '0px',
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        centerPadding: '40px'
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll:1,
        centerPadding: '40px'
      }
    },
    {
      breakpoint: 520,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        ccenterPadding: '40px'
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


  $('.mobile_slider_main').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
    arrows: false,
    dots: true,
    centerMode: true,
centerPadding: '40px'
});
	
  

function getVariantId() {
    setTimeout(function() {
        var currentPageUrl = window.location.href;
        var urlParams = new URLSearchParams(window.location.search);
        var variantId = urlParams.get('variant');  // Get the variant ID from URL parameters
        console.log("Variant ID from URL: " + variantId);

        // If no variant is found in the URL, use the first variant by default
        if (!variantId) {
            variantId = $("select[name='id']").val() || $("input[name='id']").val();  // Get variant ID from product form if no URL variant is present
        }

        // Get the quantity value
        var quantity = $("input[name='quantity']").val();  // Adjust the selector if needed
        console.log("Quantity: " + quantity);

        // Update the Buy Now button with the correct variant and quantity
        $("a#BuyNowButtonSticky").attr("href", `/cart/${variantId}:${quantity}`);
    }, 100); // Adjust the timeout duration as needed
}

// Run on page load to check for a variant ID in the URL
$(document).ready(function() {
    getVariantId();
});

// Update the Buy Now button when variant is changed
$("label").click(function() {
    getVariantId();
});

$("select").change(function() {
    getVariantId();
});

$("button.quantity-selector__button").click(function(){
    getVariantId();
});


  
});

